import React, { useCallback } from 'react';

import { CategoryID } from '../../../../../../categories/categoriesTypes';
import { GADataType } from '../../../../../../../types';

import { ThreeDStockBreadcrumbsItemType } from './ThreeDStockBreadcrumbsItem.types';

import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

interface ThreeDStockBreadcrumbsItemProps {
  item: ThreeDStockBreadcrumbsItemType;
  onSelect: (categoryId?: CategoryID) => void;
}

function ThreeDStockBreadcrumbsItem({
  dataGa,
  item,
  onSelect
}: ThreeDStockBreadcrumbsItemProps & GADataType) {
  const handleLinkClick = useCallback<() => void>(() => {
    onSelect(item.id);
  }, [item, onSelect]);

  return (
    <PureButtonHelper
      dataGa={dataGa}
      className="text-blue-600 dark:text-blue-400 hover:underline focus:ring-0 focus:ring-offset-0"
      text={item.localizedName}
      onClick={handleLinkClick}
    />
  );
}

export default ThreeDStockBreadcrumbsItem;
